<template>
  <UserDataChart v-if="$hasPermission('dashboard.read')"> </UserDataChart>
</template>

<script>
import UserDataChart from '@/modules/base/components/UserDataChart.vue'

export default {
  name: 'Dashboard',
  components: {UserDataChart}
}
</script>

